import * as React from "react";
import { Component } from "react";
import { Nav, Navbar } from "react-bootstrap";

export default class PageFooter extends Component {
  public constructor(props: any) {
    super(props);
  }

  public render() {
    const version: string = "4.0.0.17";
    return (
      <Navbar
        id="footerBar"
        bsSize="xsmall"
        className="footerBar"
        inverse={true}
        fixedBottom={true}
      >
        {window.screen.availWidth >= 768 ? (
          <Nav>
            <Navbar.Text>Copyright 2019 Culin Enterprises, Inc. All Rights Reserved.</Navbar.Text>
          </Nav>
        ) : null}
        <Nav pullRight={true}>
          {window.screen.availWidth < 768 ? (
            <Navbar.Text>Version {version} (Copyright 2019)</Navbar.Text>
          ) : (
            <Navbar.Text>Version {version}</Navbar.Text>
          )}
        </Nav>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PageFooter.tsx